import { Pipe, PipeTransform } from '@angular/core';
import { ValuationModel } from '@tfagency/core/data-access';

@Pipe({
  name: 'minMaxDisplay',
})
export class MinMaxDisplayPipe implements PipeTransform {
  transform(valuation: ValuationModel | undefined, round = false): string {
    if (!valuation) return '';

    const formatWithSpaces = (value: number | undefined, forceSign: '+' | '-'): string | null => {
      if (value === null || value === undefined) return null;

      const absolute = round ? Math.floor(Math.abs(value) / 1000) * 1000 : Math.abs(value);
      const formatted = absolute.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

      return `${forceSign} ${formatted}`;
    };

    const max = formatWithSpaces(valuation.maxValue, '+');
    const min = formatWithSpaces(valuation.minValue, '-');

    if (!max && !min) return '';
    if (max && !min) return max;
    if (!max && min) return min;
    return `${max} kr / ${min} kr`;
  }
}
